// IndexedDB wrapper for offline protocol data storage
const DB_NAME = 'yems-offline';
const DB_VERSION = 1;
const STORES = ['protocols', 'drugs', 'procedures', 'categories', 'symptoms', 'meta'];

function openDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      STORES.forEach(store => {
        if (!db.objectStoreNames.contains(store)) {
          db.createObjectStore(store, { keyPath: 'id' });
        }
      });
    };
  });
}

export async function saveToStore(storeName, data) {
  const db = await openDb();
  const tx = db.transaction(storeName, 'readwrite');
  const store = tx.objectStore(storeName);
  
  // Clear existing data
  store.clear();
  
  // If data is an array, store each item. If single object, wrap it.
  const items = Array.isArray(data) ? data : [data];
  items.forEach(item => {
    // Ensure each item has an 'id' key
    if (!item.id) item.id = item._id || storeName;
    store.put(item);
  });
  
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function getFromStore(storeName) {
  const db = await openDb();
  const tx = db.transaction(storeName, 'readonly');
  const store = tx.objectStore(storeName);
  const request = store.getAll();
  
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function getOneFromStore(storeName, id) {
  const db = await openDb();
  const tx = db.transaction(storeName, 'readonly');
  const store = tx.objectStore(storeName);
  const request = store.get(id);
  
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
  });
}

export async function getLastSyncTime() {
  try {
    const meta = await getFromStore('meta');
    const syncEntry = meta.find(m => m.id === 'lastSync');
    return syncEntry?.timestamp || null;
  } catch {
    return null;
  }
}

export async function setLastSyncTime() {
  await saveToStore('meta', [{ id: 'lastSync', timestamp: Date.now() }]);
}

export async function clearAllData() {
  const db = await openDb();
  const tx = db.transaction(STORES, 'readwrite');
  STORES.forEach(store => tx.objectStore(store).clear());
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}
